import { Box, Divider, Paper, Typography, Stack } from "@mui/material";
import { useState } from "react";
import { constants } from "../Dimension/Data/QueryConstants";
import { useHistory } from "react-router-dom";
import Atomic from "../../../AComponent/Atomic";
import { getDateFromEpoch, getUserId } from "../../../Utils/Common/Library";
import DataGrid2 from "./Table";

const { Dropdown } = Atomic;

function UserType({ rowData }) {
  console.log("Dta is: ", rowData);
  const dimensions = rowData?.Dimensions;
  const userId = getUserId();
  let type = [];
  if (dimensions?.length > 0) {
    for (let i = 0; i < dimensions.length; i++) {
      const { AppraiserID, ReviewerID } = dimensions[i];
      if (userId === AppraiserID) {
        type.push("Appraiser");
      }
      if (userId === ReviewerID) {
        type.push("Reviewer");
      }
    }
  }
  type = [...new Set(type)];
  return (
    <Stack justifyContent={"center"} height={"100%"}>
      <span>{type.join(",") || "N/A"}</span>
    </Stack>
  );
}

const planPeriods = ["2025-26", "2024-25", "2023-24", "2022-23"];

const HRView = () => {
  const history = useHistory();
  const [period, setPeriod] = useState("2025-26");

  function filterData(queryData) {
    if (!queryData) return [];
    return queryData;
  }

  const queryObj = {
    QueryName: constants.FindAllEPPWithPersonNameV3,
    RequiredFields: [],
  };

  return (
    <div className="Flex">
      <div>
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <Typography variant="h4">HR View</Typography>
          <Dropdown
            value={period}
            onChange={(value) => {
              if (value) {
                setPeriod(value);
              }
            }}
            menuItems={planPeriods}
            styles={{ width: "8rem" }}
            label={"Select Period"}
          />
        </Box>
        <Divider sx={{ margin: "2em 0" }} />
        <Paper sx={{ width: "70vw" }}>
          <DataGrid2
            query={queryObj}
            period={period}
            heading={[
              "Plan Period",
              "Employee code",
              "Employee Name",
              "Start Date",
              "End Date",
              "User Type",
            ]}
            valueFormatter={{
              PlanStartDate: (val) => getDateFromEpoch({ epoch: val }),
              PlanEndDate: (val) => getDateFromEpoch({ epoch: val }),
            }}
            rowToFieldMap={[
              "PlanPeriod",
              "AppraiseeUserEmployeeCode",
              "AppraiseeUserFullName",
              "PlanStartDate",
              "PlanEndDate",
              {
                Component: UserType,
                props: {},
              },
            ]}
            filterQueryData={(queryData) => {
              return filterData(queryData);
            }}
            onRowClicked={({ data }) => {
              const Plan = data;
              if (!Plan.Dimensions) Plan.Dimensions = [];
              if (!Plan.Sections) Plan.Sections = [];
              localStorage.setItem("EPP_NAV_LOCATION", "/hrview");
              history.push({ pathname: "/pms", state: { Plan } });
            }}
          />
        </Paper>
      </div>
    </div>
  );
};

export default HRView;
